<template>
    <tabbed-menu
            :initial-tab="initialTab"
            :tabs="[{
                    name: tabs.touchpointStatistics,
                    label: this.resource('JourneyBuilder_TouchpointOverview_Tab_Statistics'),
                    isDisabled: disableStatistics
                }, {
                    name: tabs.touchpointInfo,
                    label: this.resource('JourneyBuilder_TouchpointOverview_Tab_Info')
            }]"
    >   
        <template :slot="tabs.touchpointStatistics">
            <touchpoint-statistics
                class="tab-pane show active"
                role="tabpanel"

                    :brick-id="brickId"
            />
        </template>

        <template :slot="tabs.touchpointInfo">
            <touchpoint-info
                class="tab-pane show active"
                role="tabpanel"

                :name="name"
                :type="type"
                :config="config"
                :incoming-connections-info="incomingConnectionsInfo"
                :outgoing-connections-info="outgoingConnectionsInfo"
            />
        </template>
    </tabbed-menu>
</template>

<script>
    import resourceMixin from "@core/Util/Mixins/resources";
    
    import TabbedMenu from "@core/Components/Navigation/TabbedMenu.vue";
    import TouchpointInfo from "./TouchpointInfo.vue";
    import TouchpointStatistics from "./Statistics/TouchpointStatistics.vue";
    
    const tabs = {
        touchpointStatistics: 'touchpointStatistics',
        touchpointInfo: 'touchpointInfo'
    };
    
    const defaultTab = tabs.touchpointInfo;
    
    export default {
        name: 'touchpoint-overview',
        components: {
            TabbedMenu,
            TouchpointStatistics,
            TouchpointInfo
        },
        mixins: [resourceMixin],
        data: () => ({ tabs }),
        props: {
            brickId: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            type: {
                type: Number,
                required: true
            },
            config: {
                type: Object,
                required: true
            },
            disableStatistics: {
                type: Boolean,
                required: true
            },
            incomingConnectionsInfo: {
                type: Array,
                required: true
            },
            outgoingConnectionsInfo: {
                type: Array,
                required: true
            },
            initialTab: {
                type: String,
                default: defaultTab,
                required: false
            }
        }
    }

    export {
        tabs,
        defaultTab
    }
</script>

<style scoped lang="scss">
    @import "~@modules/JourneyBuilder/Style/Shared/tabbed-menu.scss";
</style>